import { Controller } from "stimulus"
import { daterangepicker } from "../vendor/daterangepicker";

export default class extends Controller {
    static targets = [ "submit" ]

    connect() {

    }

    //Prevent autofocusing on top form field after battery row is replaced by turbo.
    unfocusBeforeSubmit(event) {
        if (event.key === "Enter") {
            const active = document.activeElement
            if (active && ["INPUT", "TEXTAREA"].includes(active.tagName)) {
                event.preventDefault()
                active.blur()
                active.form?.requestSubmit()
            }
        }
    }


    clearQrInput(event) {
        const button = event.currentTarget
        const input = document.getElementById(button.dataset.qrCodeInputId)
        input.value = ""
        button.remove()
    }
}